module.exports = __webpack_public_path__ + "img/holiday-jumble-banner-300w.b104e492.jpg";